/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { readStore } from '../../../mobx/stores/rf';
// import ProgressText from '../../../components/progress-text/Progress';
import SubContent from '../../../components/sub-content/SubContent';
import ProcessInfo from '../../../native-interact/ProcessInfo';
// import Bluetooth from '../Bluetooth';
import Button from '../../../components/button/Button';
import { stepStore } from '../../../mobx/stores/step';
// import Message from '../../../components/message';
import '../RfLog.scss';

const processInfo = new ProcessInfo();

class BaseInfo extends Component {
  // constructor() {
  //   super();
  //   this.state = {};
  // }

  componentDidMount() {
    stepStore.allLoad = false;
  }

  componentDidUpdate() {
    const { show } = this.props;
    const { allLoad } = stepStore;
    // if (show && !allLoad) processInfo.start();
  }

  getStatus() {
    const { status } = readStore;
    return status;
  }

  //   closeLog = () => {
  //     this.props.onCloseLog();
  //   }

  // 获取地磁模式
  getMode(mode) {
    if (!mode) return false;
    const modeArray = mode.split('');
    const strCode = `${modeArray[6]}${modeArray[7]}`;
    let codeShutdown;
    if (strCode === '80') {
      codeShutdown = '80低电保护';
    } else if (strCode === '81') {
      codeShutdown = '81网络异常';
    } else {
      codeShutdown = '00运行正常';
    }
    return codeShutdown;
  }

  // 获取地磁进入异常模式的时间
  getInitModeTime(modeTime) {
    if (!modeTime) return false;
    // const t = 'FDF6A205';
    const timeArray = modeTime.split('');
    const timeStr = `${timeArray[6]}${timeArray[7]}${timeArray[4]}${timeArray[5]}${timeArray[2]}${timeArray[3]}${timeArray[0]}${timeArray[1]}`;
    const time = parseInt(timeStr, 16);
    const baseTime = (new Date('2018/01/01 00:00:00')).getTime() / 1000;
    const endTime = (Number(baseTime) + Number(time)) * 1000;
    const initTime = new Date(endTime);
    const y = initTime.getFullYear();
    const m = initTime.getMonth() + 1;
    const d = initTime.getDate();
    const h = initTime.getHours();
    const mm = initTime.getMinutes();
    const s = initTime.getSeconds();
    return `${y}-${m}-${d} ${h}:${mm}:${s}`;
  }

  next = () => {
    // const { status } = readStore;
    // if (status === 'loading') {
    //   Message.confirm('任务正在执行中，是否直接跳转下一步？', () => {
    //     processInfo.stopNext();
    //     this.props.onCloseLog();
    //   }, () => {});
    // } else {
    //   this.props.onCloseLog();
    // }
    this.props.onCloseLog();
  }

  render() {
    const { show } = this.props;
    const { RFID, projectParam, rf } = readStore;
    // const { status } = btStore;
    // const rfStatus = this.getStatus.call(this);
    // 根据store中设置的需要读取的字段设置显示的内容组件
    const projectContent = [];
    const NBContent = [];

    // 项目参数信息
    Object.keys(projectParam).forEach((key) => {
      const item = projectParam[key];
      if (key === 'detectType') {
        const detects = [];
        projectParam[key].value.forEach((device) => {
          // eslint-disable-next-line no-unused-expressions
          device.value && detects.push(device.name);
        });
        projectContent.push(<p key={key}>{`${item.name}：${detects.join(',')}`}</p>);
      } else {
        projectContent.push(<p key={key}>{`${item.name}：${item.value}`}</p>);
      }
    });

    // 只有NB地磁才有IMEI/IMSI/ICCID
    if (projectParam.communicateType.value === 'NB') {
      Object.keys(rf).forEach((key) => {
        let value = '';
        if (key === 'MODE') {
          value = this.getMode(rf[key]);
        } else if (key === 'MODETIME') {
          value = this.getInitModeTime(rf[key]);
        } else {
          value = rf[key];
        }
        NBContent.push(<p key={key}>{`${key.toUpperCase()}：${value}`}</p>);
      });
    }

    return (
      <div className="rflog" style={{ display: show ? 'block' : 'none' }}>
        {/* <ProgressText
          text="读取信息时请将读卡器放置于地磁上方"
          hasPre
        /> */}
        {/* <div className="baseinfo-title">读取信息时请将读卡器放置于地磁上方</div> */}
        <SubContent>
          <p>RFID：{RFID}</p>
          {[...projectContent, ...NBContent]}
        </SubContent>
        <div className="btn-wrap">
          <Button type="primary" size="mini" onClick={this.next}>关闭</Button>
        </div>
      </div>
    );
  }
}

export default observer(BaseInfo);
